<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/sppd">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading">
            <div slot="title">
              SPPD/S Manifest
              <small class="m-display-block m-text-small">{{
                data.header.no_sppd
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottomRight">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button-group type="dashed">
                    <a-button
                      @click="handlePrintManifest"
                      icon="printer"
                      :loading="printLoad.manifest"
                      >Manifest</a-button
                    >
                    <a-button
                      icon="printer"
                      @click="handlePrintSpk"
                      :loading="printLoad.spk"
                      >SPK</a-button
                    >
                    <a-button
                      v-if="data.close_sts"
                      type="danger"
                      icon="close"
                      @click="handleClose"
                      :loading="printLoad.close"
                      >Close</a-button
                    >
                  </a-button-group>
                </li>
                <li v-if="getAuth.username == data.header.user_pembuat">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.lastStatus == 'Revised' &&
                          getAuth.username == data.header.user_pembuat
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        !(
                          data.lastStatus == 'Revised' &&
                          getAuth.username == data.header.user_pembuat &&
                          data.canceled_sts
                        )
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title">Cost Center</span>
                  <span class="m-list-desc">{{ data.header.cost_center }}</span>
                </li>
                <li>
                  <span class="m-list-title">Peruntukan</span>
                  <span class="m-list-desc">{{
                    data.header.allocation
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Assignee</span>
                  <ul v-for="assignee in data.assignee" :key="assignee.noo">
                    <li class="m-list-desc">{{ assignee.nama }}</li>
                  </ul>
                </li>
                <li>
                  <span class="m-list-title" for
                    >Business trip (PD) schedule</span
                  >
                  <span class="m-list-desc"
                    >{{ data.header.tgl_mulai }} -
                    {{ data.header.tgl_selesai }}</span
                  >
                </li>
                <li>
                  <span class="m-list-title" for>Estimated Cost (IDR)</span>
                  <span class="m-list-desc">{{ formatCurrency('IDR', data.header.est_cost).replaceAll('Rp', '') }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{ data.header.deskripsi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Work Unit</span>
                  <span class="m-list-desc">{{ data.header.satker }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Address</span>
                  <span class="m-list-desc">{{ data.header.alamat }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Contact person</span>
                  <span class="m-list-desc">{{
                    data.header.contact_person
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Transportation</span>
                  <span class="m-list-desc">{{
                    data.header.transportasi
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Accomodation</span>
                  <span class="m-list-desc">{{ data.header.akomodasi }}</span>
                </li>
                <!-- <li v-if="data.header.type_activity">
                  <span class="m-list-title" for>Activity Type</span>
                  <span class="m-list-desc">{{ data.header.type_activity }}</span>
                </li>
                <li v-if="data.header.activity">
                  <span class="m-list-title" for>Activity</span>
                  <span class="m-list-desc">{{ data.header.activity }}</span>
                </li>
                <li v-if="data.header.pipeline_no">
                  <span class="m-list-title" for>Pipeline</span>
                  <span class="m-list-desc">{{ data.header.pipeline_no && data.header.pipeline_no!=null ? (data.header.pipeline_no+" | "+ data.header.definitions) : '-'}}</span>
                </li> -->
                <li v-if="data.header.no_prospek">
                  <span class="m-list-title" for>Prospect</span>
                  <span class="m-list-desc">{{ data.header.no_prospek }} - {{ data.header.description }}</span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-card v-if="getScreen">
            <div slot="title">Usage Details</div>
            <a-list
                    itemLayout="vertical"
                    :dataSource="data.tableData"
                    :pagination="pagination"
            >
              <Empty
                      v-if="
                  data.tableData
                    ? data.tableData.length <= 0
                    : data.tableData
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <span>{{ item.item_anggaran }}</span><br/>
                  </div>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex space-between">
                      <span>{{ item.kode_anggaran }}</span>
                    </div>
                    <div>
                      <span>{{ formatRupiah(item.value, "IDR" ) }}</span>
                    </div>
                    <div v-if="Number(item.bailout_value)>0">
                      <span>@bailout - {{ formatRupiah(item.bailout_value, "IDR" ) }}</span>
                    </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
              <div  slot="footer" class="m-price-total">
                <span v-if="totalBailout>0" class="m-list-title">
                  Total Bailout :
                  {{
                  formatRupiah(totalBailout, "IDR" )
                  }}
                </span>
              </div>
            </a-list>

          </a-card>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-input-search
                      v-model="search"
                      placeholder="Quick Search"
                      allowClear
                      :change="searching"
                      class="margin-bottom"
              />
              <a-table
                      :columns="columns"
                      :dataSource="data.tableData"
                      :pagination="pagination"
                      rowKey="id_sppd_dtl"
                      size="small"
                      bordered
                      :scroll="{ x: 100 }">

                <template slot="anggaran" slot-scope="item">
                  <span>{{item.item_anggaran}}</span><br/>
                  <b>{{item.kode_anggaran}}</b>
                </template>
                <template slot="val" slot-scope="item">
                  <CurrencyJustified :currencyValue="'IDR'" :valueNumber="item.value" />
                </template>
                <span slot="bailout" slot-scope="item">
                  <CurrencyJustified
                    v-if="item.bailout_value"
                    :currencyValue="'IDR'"
                    :valueNumber="item.bailout_value"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <template slot="footer">
                  <span v-if="totalBailout>0" class="m-list-title">
                    Total Bailout :
                    {{
                    formatRupiah(totalBailout, "IDR" )
                    }}
                  </span>
                </template>
              </a-table>
            </a-collapse-panel>
          </a-collapse>

          <a-card
                  :class="getScreen ? 'margin-bottom margin-top' : 'margin-top'"
                  :loading="loading"
                  v-if="!getScreen && (data.jenis === 'Approve' || data.jenis === 'Verifikator')"
          >
            <div slot="title">Manifest actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="['catatan_sppds']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                        showSearch
                        v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                    }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                        @click="handleAction"
                        block
                        type="primary"
                        html-type="submit"
                >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>



        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status
                    :status="
                      data.lastStatus == 'Approved' &&
                      data.header.close_sts == 1
                        ? 'Close'
                        : data.lastStatus
                    "
                  />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.header.user_pembuat }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ data.header.tgl_sppd }}</h4>
                    <span class="m-text-small" v-if="data.header.remark">{{
                      data.header.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.workflowStatus"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">SPPD Allocated Directorate 
                  ({{ data.remark_pd_keuangan?data.remark_pd_keuangan.direktorat:'-' }})</h4>
              </div>
              <Empty v-if="data.remark_pd_keuangan === null" />
              <div v-else>
                <span
                  v-if="data.remark_pd_keuangan.dt != '-'"
                  class="m-timeline-title"
                  >{{
                    data.remark_pd_keuangan.tlc
                      ? data.remark_pd_keuangan.tlc
                      : "-"
                  }}
                  /
                  {{
                    data.remark_pd_keuangan.dt
                      ? moment(
                          data.remark_pd_keuangan.dt,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      : "-"
                  }}
                </span>
                <br v-if="data.remark_pd_keuangan.dt != '-'" />
                <span
                  class="m-text-small"
                  v-if="data.remark_pd_keuangan.remark"
                >
                  {{ data.remark_pd_keuangan.remark }}</span
                >
                <span class="m-text-small" v-else> Tidak ada catatan</span>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Evidence Bailout</h4>
              </div>
              <Empty v-if="data.bailout && data.bailout.length==0" />
              <div v-else class="m-display-flex space-between align-middle">
                <div>
                  <span
                    v-if="data.bailout && data.bailout.transfer_dt != '-'"
                    class="m-timeline-title"
                    >{{
                      data.bailout.tlc_kas
                        ? data.bailout.tlc_kas
                        : "-"
                    }}
                    /
                    {{
                      data.bailout && data.bailout.transfer_dt
                        ? moment(
                            data.bailout.transfer_dt,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                  <br v-if="data.bailout && data.bailout.transfer_dt != '-'" />
                  <span
                    class="m-text-small"
                    v-if="data.bailout && data.bailout.note_transfer"
                  >
                    {{ data.bailout.note_transfer }}</span
                  >
                  <span class="m-text-small" v-else> Tidak ada catatan</span>
                </div>
                <a-button
                  v-if="data.bailout && data.bailout.file_transfer!=null"
                  class="margin-top"
                  style="margin-right: 10px"
                  @click="handleViewBailout(data.bailout.file_transfer)"
                  type="default"
                  icon="eye"
                  size="small"
                >View</a-button>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    type="default"
                    size="small"
                    class="margin-right-small"
                    v-if="isallowUploadAttachment"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.file_attachment">
                <Empty
                  v-if="
                    data.file_attachment ? data.file_attachment.length <= 0 : data.file_attachment
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(item)"
                        class="margin-remove m-text-dots"
                      >
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                        <!-- <a-button
                          v-if="data.header.user_pembuat === getAuth.username"
                          @click="handleRemoveExisting(item.id_sppd_doc)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button> -->
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>

                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            :class="getScreen ? 'margin-bottom margin-top' : 'margin-top'"
            :loading="loading"
            v-if="getScreen && (data.jenis === 'Approve' || data.jenis === 'Verifikator')"
          >
            <div slot="title">Manifest actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan_sppds']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachments
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input
            autocomplete="off"
            v-decorator="['fungsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemoveModal"
            v-decorator="[
              'file_list_lampiran',
              { rules: [{ required: true }] },
            ]"
            :fileList="fileListModalLampiran"
            :showUploadList="true"
            :disabled="fileListModalLampiran.length > 0"
            :beforeUpload="beforeUploadModal"
          >
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleUploadLampiran"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import Axios from "axios";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "manifest",
  props: ["id", "user_pembuat"],
  components: { "m-anim": lottie, Status },
  mixins: [HandleRoute, CurrencyFormat, GlobalMethod],
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsSpecialMenu",
      "getStandartFormatDate",
      "getDateTimeFormat",
      "getDefaultDateFormat"
    ]),

    searching() {
      if (this.search) {
        let tdt = this.tableDataTemp
        this.data.tableData = tdt.filter(
                (obj) =>
                obj.item_nm &&
                obj.item_nm.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                obj.item_anggaran &&
                obj.item_anggaran.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                obj.kode_anggaran &&
                obj.kode_anggaran.toLowerCase().indexOf(this.search.toLowerCase()) >= 0,
        );
      }

      if (!this.search) {
        this.data.tableData = this.tableDataTemp;
      }

      return this.data.tableData;
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          align: "right",
          width: "55px",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Activity Name",
          dataIndex: "item_nm",
          width: "200px",
          key: "item_nm",
        },
        {
          title: "Value",
          scopedSlots: { customRender: "val" },
          width: "150px",
          key: "val",
        },
        {
          title: "Anggaran",
          key: "kode_anggaran",
          width: "200px",
          scopedSlots: { customRender: "anggaran" },
        },
        {
          title: "Bailout Value",
          key: "bailout",
          width: 100,
          scopedSlots: { customRender: "bailout" },
        },
      ];
      return kolom;
    },
    isallowUploadAttachment(){
      return _.filter(this.data.assignee, (item)=>{return item.tlc==this.getAuth.username}).length>0 
        || this.getAuth.username==this.data.header.user_pembuat
    },
    totalBailout(){
      let total = 0;
      this.data.tableData.forEach(item => {
          total = total + Number(item.bailout_value);
      });

      return total;
    }
  },
  data() {
    return {
      loading: true,
      printLoad: {
        manifest: false,
        spk: false,
        cancel: false,
        close: false,
      },
      notfound: { animationData: notfound, loop: true },
      id_sppd: this.id,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      data: {
        close_sts: false,
        header: [],
        assignee: [],
        lastStatus: "",
        mengetahui: [],
        history: [],
        workflowStatus: [],
        jenis: null,
        aksi: null,
        dokumen_terkait: [],
        tableData:[],
        remark_pd_keuangan: {},
        bailout: [],
      },
      visibleHistory: false,
      search: "",
      canceled_sts: false,
      lampiran: [],
      visibleLampiran: false,
      fileListModalLampiran: [],
    };
  },
  mounted() {
    this.fetchManifest(this.id);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("handleCancel", this.canceltrans);
  },
  watch: {
    id() {
      if (this.id) {
        this.id_sppd = this.id;
        this.fetchManifest(this.id);
      }
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchManifest(to.params.id);
    next();
  },
  methods: {
    moment,
    fetchManifest(idValue) {
      this.loading = true;

      Axios({
        method: "get",
        url: this.$serviceUrl + "sppds",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: idValue,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data.header = response.data.header[0];
          this.data.assignee = response.data.assignee;
          this.data.lastStatus = response.data.last_status;
          this.data.mengetahui = response.data.mengetahui;
          this.data.history = response.data.notifikasi;
          this.data.workflowStatus = response.data.status_app;
          this.data.jenis = response.data.jenis;
          this.data.aksi = response.data.aksi;
          this.data.dokumen_terkait = response.data.dokumen_terkait;
          this.data.tableData = response.data.detail_sppd;
          this.data.remark_pd_keuangan = response.data.remark_pd_keuangan[0];
          this.data.file_attachment = response.data.file_attachment
          this.data.bailout= response.data.bailout[0]
          this.data.close_sts = response.data.close_sts

          this.data.tableData.forEach((item,index)=>{
            item.no = index+1
          });

          this.data.canceled_sts = response.data.canceled_sts

          this.tableDataTemp = this.data.tableData;

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("choose-again");
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        axios({
          method: "put",
          url: this.$serviceUrl + "sppds/approval ",
          processData: false,
          data: {
            id_sppd: this.id_sppd,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan_sppds ? values.catatan_sppds : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds/cetakmanifest",
        responseType: "blob",
        params: {
          id_sppd: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlePrintSpk() {
      this.printLoad.spk = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds/cetakspk",
        responseType: "blob",
        params: {
          id_sppd: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.spk = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.spk = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "sppds",
        id_manifest: this.id,
        code_trans: this.data.header.no_sppd,
        kode_project: this.data.header.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "edit",
        params: { id: this.id, type: "revised" },
      });
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    handleDownload(item) {
      // if (item.source === "simfoni") {
      window.open(this.$serviceUrl + "assets/upload/doc_sppd/"+item.nama_file, "_blank");
      // } else {
      //   window.open(item.link, "_blank");
      // }
    },
    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    handleRemoveLampiran(item) {
      this.loading.page = true;
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "addendum/lampiran",
        processData: false,
        data: {
          id_addendum_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.loading.page = false;
          Event.$emit("refresh", true);
          this.displayMessage("success-del");
        })
        .catch((err) => {
          this.loading.page = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    cancelLampiran() {
      this.fileListModalLampiran = [];
      this.formLampiran.resetFields();
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileListModal.push(file);
        } else {
          this.fileListModalLampiran.push(file);
        }
        return false;
      }
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "sppds/upload_attachment",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            // this.$router.go()
            // this.$router.go()
            // const route = this.$router.resolve({
            //   name: this.$route.name,
            //   params: { id: this.id },
            // });
            // window.open(route.href, "_blank");
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleViewBailout(path){
      window.open(this.$serviceUrl + path);
    },
    handleClose(){
      let formData = new FormData();
      formData.append("id_sppd", this.id);

      this.printLoad.close = true
      Axios({
        method: "post",
        url: this.$serviceUrl + "sppds/close",
        processData: false,
        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then(() => {
          this.displayMessage("success-close");
          this.printLoad.close = false
          this.$router.go()
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    }
  },
};
</script>

<style lang="less" scoped></style>
